<template>
  <div class="activityCheck">
    <div class="activityCheckBox">
      <el-row>
        <el-col :span="22">检查活动</el-col>
        <el-col :span="2">
          <el-button
            type="info"
            round
            icon="el-icon-back"
            size="small"
            @click="goBack()"
          >
            返 回
          </el-button>
        </el-col>
      </el-row>
      <div class="leftPart">
        <div class="leftFilters">
          <el-row :gutter="10" class="filter">
            <el-col :span="8">
              <el-select
                class="area"
                v-model="filterData.region"
                placeholder="请选择区域"
                @change=changeFilter
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.no"
                  :label="item.name"
                  :value="item.no">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select
                class="area"
                v-model="filterData.province"
                placeholder="请选择省份"
                @change=changeFilter
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.no"
                  :label="item.name"
                  :value="item.no">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select
                class="area"
                v-model="filterData.city"
                placeholder="请选择城市"
                @change=changeFilter
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.no"
                  :label="item.name"
                  :value="item.no">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="filter">
            <el-col :span="8">
              <el-select
                class="area"
                v-model="filterData.reseller"
                placeholder="请选择客户"
                @change=changeFilter
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.no"
                  :label="item.name"
                  :value="item.no">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select
                class="area"
                v-model="filterData.secondReseller"
                placeholder="请选择二级客户"
                @change=changeFilter
              >
                <el-option
                  v-for="item in secondResellerList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select
                class="area"
                v-model="filterData.concept"
                placeholder="请选择门店类型"
                @change=changeFilter
              >
                <el-option
                  v-for="item in rankList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="filter">
            <el-col :span="8">
              <el-select
                class="area"
                v-model="filterData.domain"
                placeholder="请选择直营/加盟"
              >
                <el-option
                  key="ND"
                  label="直营"
                  value="ND">
                </el-option>
                <el-option
                  key="NSP"
                  label="加盟"
                  value="NSP">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
            </el-col>
          </el-row>
          <el-row class="filter">
            <el-col :span="24">
              <el-button
                type="success"
                @click="searchStore()"
              >
                查询
              </el-button>
              <el-button
                type="plain"
                @click="clearFilter()"
                :style="'margin-left: 2px'"
              >
                重置
              </el-button>
            </el-col>
          </el-row>
        </div>
        <el-tabs class="tabs" :stretch="true" v-model="storeConfig.status" @tab-click="handleTabChange">
          <div style="margin-top: 15px;">
            <el-input placeholder="搜索门店" v-model="storeConfig.name" class="search">
              <el-button slot="append" icon="el-icon-search" @click="searchStore()"></el-button>
            </el-input>
          </div>
          <ul class="storeList">
            <li
              v-for="item in storeData" @click="getStoreDetail(item.id)"
              :key="item.id"
              :class="{ active: selectedId === item.id }"
              :title="item.name"
            >
              {{ item.doorNo }} {{ item.name }}
            </li>
          </ul>
          <el-tab-pane :label="'待检查 ' + storeDataAmount.checkedCount" name="2">
          </el-tab-pane>
          <el-tab-pane :label="'未通过 ' + storeDataAmount.notPassCount" name="3">
          </el-tab-pane>
          <el-tab-pane :label="'已完成 ' + storeDataAmount.completedCount" name="4">
          </el-tab-pane>
          <el-tab-pane :label="'未上传 ' + storeDataAmount.uploadedCount" name="1">
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="rightPart">
        <div class="detailBox">
          <el-form ref="form" :model="storeDetail" label-width="100px">
            <el-form-item label="门店名称:" class="sticky-header">
              {{ this.storeDetail.door.doorNo }} {{ this.storeDetail.door.name }}
            </el-form-item>
            <el-form-item label="陈列区域:">
              <div>
                <template v-for="(pic, index) in storeDetail.activityDoorDisplayAreaList">
                  <div class="title">{{ pic.displayAreaName }}</div>
                  <div class="title">
                    <pre>{{ pic.detail }}</pre>
                  </div>
                  <div class="sub-title">历史:</div>
                  <div class="history-images">
                    <template v-for="(imgGroup, gIdx) in (pic.historyImageList || [])" :key="gIdx">
                      <div class="history-group">
                        <el-image
                          v-for="(imgUrl, iIdx) in imgGroup"
                          :key="`${gIdx}-${iIdx}`"
                          class="history-preview-img"
                          :src="imgUrl"
                          :preview-src-list="imgGroup"
                          :initial-index="iIdx"
                          :z-index="3000"
                          fit="cover"
                        />
                      </div>
                    </template>
                  </div>
                  <div class="sub-title">最新:</div>
                  <div class="images">
                    <el-image
                      v-for="img in (previewGroups[index] || [])"
                      :key="img.index"
                      class="previewImage"
                      :src="img.src"
                      :preview-src-list="previewImages"
                      :initial-index="img.index"
                      :z-index="3000"
                    />
                  </div>
                  <div class="title">{{ pic.remarks }}</div>
                  <div class="quickReplyResult" v-if="pic.replyList && pic.replyList.length">
                    <ul>
                      <li v-for="(reply) in pic.replyList">
                        {{ reply.realName }} {{ reply.createTime }} {{ reply.content === '' ? '无' : reply.content }}
                      </li>
                    </ul>
                  </div>
                  <div class="quickReply" v-if="storeConfig.status !=='4' && storeConfig.status !=='3'">
                    <el-radio v-model="quickReplyList[index]" border size="medium" v-for="(item, qri) in quickReplyListOptions" :key="qri" :label="item.id + '*' + item.content">{{ item.content }}</el-radio>
                    <el-input placeholder="请输入回复" v-model="replyContentList[index]" clearable style="width: 68%"></el-input>
                  </div>
                  <hr>
                </template>
              </div>
            </el-form-item>
            <el-form-item label="备注">
              {{ storeDetail.activityDoor.remarks }}
            </el-form-item>
            <el-form-item label="检查者留言">
              <el-input type="textarea" v-model="content"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <footer v-if="storeConfig.status == 2 && activeId > 0">
          <el-button type="info" @click="approve(0)">
            不通过
          </el-button>
          <el-button type="success" @click="approve(1)">
            通过
          </el-button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";

export default {
  name: "UserEdit",
  data() {
    return {
      id: this.$route.query.id || null,
      activeId: 0,  //当前选中的门店
      selectedId: null,
      storeData: [],
      storeDetail: {  //右侧门店详情
        door: {
          name: "",
          doorNo: ""
        },
        activityDoor: {
          remarks: "" // 备注
        },
        activityDoorDisplayAreaList: [  //区域图片
          {
            displayAreaName: "",
            imageLink1: "",
            imageLink2: "",
            imageLink3: "",
            imageLink4: "",
            imageLink5: "",
            imageLink6: "",
            imageList: [],
            isPass: false,
            historyImageList: []
          }
        ],
        inspectorReplyList: [ //审批回复
          {
            content: "",
            realName: "",
            createTime: "",
          }
        ],
        passLabel: ""
      },
      quickReplyList: [],
      replyContentList: [],
      quickReplyListOptions: [],
      content: "", //审批留言
      storeDataAmount: {  //四种状态的门店数
        checkedCount: 0,
        notPassCount: 0,
        completedCount: 0,
        uploadedCount: 0
      },
      storeConfig: {  //搜索条件
        activityId: '0',
        status: "2",
        name: '',
        current: ''
      },
      approveForm: {  //审核表单
        activityDoorId: "",
        content: "",
        status: "",
      },
      filterData: {},
      initialFilterData: {
        region: '', //区域
        city: '', //城市
        reseller: '', //客户
        concept: '', //等级
        province: '', //省份
        secondReseller: '',
        domain: '',
        hubDoor: '', //是否hubdoor
        masterV: '', //是否MasterV
      },
      areaList: [],
      cityList: [],
      customerList: [],
      rankList: [],
      provinceList: [],
      secondResellerList: [],
      tableData: [], // 列表
      total: 10, // 总数量
      tableConfig: {
        size: 10, // 每页数量
        current: 1, // 当前页码
      },
      tableLoading: false
    }
  },
  mounted() {
    this.clearFilter();
    this.getOptions();
    if (this.id) {
      this.storeConfig.activityId = this.id;
      this.getData()
    }
  },
  computed: {
    /**
     * 把 activityDoorDisplayAreaList 下每一项的 imageList 合并成一个列表，
     * 同时记录每张图片在合并列表中的下标，用于点击任意一张时从该张开始预览、并跨区域左右切换。
     */
    previewImages() {
      return this.previewGroups.reduce((all, group) => all.concat(group.map(img => img.src)), []);
    },
    previewGroups() {
      let start = 0;
      return (this.storeDetail.activityDoorDisplayAreaList || []).map(area => {
        const group = ((area && area.imageList) || [])
          .filter(src => !!src)
          .map((src, i) => ({src, index: start + i}));
        start += group.length;
        return group;
      });
    },
  },
  methods: {
    async getData() {
      this.initStoreData()

      console.log('this.filterData', this.filterData)
      let params = _.assignIn(_.cloneDeep(this.filterData), this.storeConfig)
      params.cityNo = params.city
      params.provinceNo = params.province
      params.regionNo = params.region
      params.resellerNo = params.reseller
      let res = await axios.post(vmsReqUrl + "activityDoor/inspectionDoorList", params);
      res = res.data
      if (res.code === 200) {
        this.storeData = res.data.records;
        this.storeDataAmount.checkedCount = res.data.checkedCount;
        this.storeDataAmount.notPassCount = res.data.notPassCount;
        this.storeDataAmount.completedCount = res.data.completedCount;
        this.storeDataAmount.uploadedCount = res.data.uploadedCount;
      }
    },
    initStoreData() { //初始化详情数据
      this.activeId = 0;
      this.storeDetail.door.name = "";
      this.storeDetail.activityDoor.remarks = "";
      this.storeDetail.activityDoorDisplayAreaList = [];
      this.storeDetail.content = "";
      this.storeDetail.inspectorReplyList = [];
    },
    async getOptions() {
      const params = {}
      params.city = this.filterData.city ? [this.filterData.city] : []
      params.concept = this.filterData.concept ? [this.filterData.concept] : []
      params.province = this.filterData.province ? [this.filterData.province] : []
      params.region = this.filterData.region ? [this.filterData.region] : []
      params.reseller = this.filterData.reseller ? [this.filterData.reseller] : []

      params.domain = this.filterData.domain
      params.hubDoor = this.filterData.hubDoor
      params.masterV = this.filterData.masterV
      params.secondReseller = this.filterData.secondReseller

      console.log('params', params)
      let res = await axios.post(vmsReqUrl + "door/queryConditions", params);
      if (res.data.code === 200) {
        const dataList = res.data.data;
        this.areaList = dataList.region;
        this.cityList = dataList.city;
        this.rankList = dataList.concept;
        this.customerList = dataList.reseller;
        this.provinceList = dataList.province;
        this.secondResellerList = dataList.secondReseller
      }
    },
    clearFilter() {
      this.filterData = _.cloneDeep(this.initialFilterData);
      this.getOptions();
    },
    changeFilter() {
      this.getOptions();
    },
    goBack() {
      this.$router.back();
    },
    save() {
    },
    searchStore() {
      this.getData()
    },
    async getStoreDetail(id) { //查询门店详情
      this.selectedId = id;
      this.quickReplyList = []
      this.activeId = id;
      let res = await axios.post(vmsReqUrl + "activityDoor/inspectionDoorDetails/" + id);
      res = res.data
      if (res.code === 200) {
        this.storeDetail = res.data;
        this.quickReplyListOptions = res.data.quickReplyList
        for (var i = 0; i < this.storeDetail.activityDoorDisplayAreaList.length; i++) {
          if (this.storeDetail.activityDoorDisplayAreaList[i].isPass) {
            this.quickReplyList.push(this.storeDetail.passLabel)
          } else {
            this.quickReplyList.push('')
          }
        }

        // 组装审批数据
        let contentStr = "";
        this.storeDetail.inspectorReplyList.forEach(item => {
          contentStr += item.realName + " " + item.createTime + " " + item.content;
        })
        this.content = contentStr;
      }
    },
    handleTabChange(tab, event) {
      this.storeConfig.status = String(tab.name)
      this.getData()
    },
    // 审核1：通过，0不通过
    async approve(status) {
      const submitData = _.cloneDeep(this.approveForm)
      submitData.content = this.content;
      submitData.status = status;
      submitData.activityDoorId = this.activeId;
      const quickReplyList = []
      let hasError = false
      _.each(this.quickReplyList, (quickReply, index) => {
        console.log('quickReply', quickReply)
        let content = ''
        if (quickReply.indexOf("*") !== -1) {
          // 这个id是快捷回复的id
          const [id, idContent] = quickReply.split('*')
          content = idContent
        } else {
          hasError = true
          this.$message.error('第' + (index + 1) + '项请选择审核结果')
          return false
          content = quickReply
        }

        // 追加自定义回复
        var replyConent = this.replyContentList[index];
        if (content.length > 0) {
          if (replyConent && replyConent.length > 0) {
            content += '-' + replyConent
          }
        } else {
          content = replyConent
        }

        // 这个id是对应那一块的id
        const submitId = this.storeDetail.activityDoorDisplayAreaList[index].id
        quickReplyList.push({
          id: submitId,
          content: content || ''
        })
      })
      submitData.quickReplyList = quickReplyList
      console.log('submitData', submitData)
      if (hasError) {
        return false
      }
      let res = await axios.post(vmsReqUrl + "activityDoor/doorApprove", submitData);
      res = res.data
      if (res.code === 200) {
        this.quickReplyList = []
        this.replyContentList = []
        await this.getData();
      }
    },
  }
};
</script>
<style lang="sass" scoped>
.activityCheck
  .activityCheckBox
    padding: 20px

    .formBox
      width: 80%
      margin-left: 20%

    h5
      margin: 0
      font-size: 14px

    .checkboxBox
      label
        display: block
        float: left
        width: 40%
        padding: 30px 0 0
        font-weight: 400

    footer
      padding-top: 30px
      text-align: center

  .leftPart
    width: 460px
    position: fixed
    border: 1px solid #DCDFE6
    height: calc(100% - 177px)
    border-radius: 4px
    background: #fff
    padding: 0 12px 12px
    overflow: auto
    margin-top: 20px

    .filter
      margin-top: 10px

    ul.storeList
      width: 100%
      height: 100%
      padding: 0
      margin: 10px 0 0 0
      font-size: 14px
      border: 1px solid #DCDFE6
      border-radius: 4px
      box-sizing: border-box

      li
        list-style: none
        padding: 0 6px
        height: 36px
        line-height: 36px
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
        border-bottom: 1px solid #DCDFE6

        img
          width: 30px
          vertical-align: middle

    .tabs
      width: 100%

    ul.storeList
      li.active
        background: #E6F7FF

  .rightPart
    width: calc(100% - 770px)
    height: calc(100% - 177px)
    padding: 0 12px 12px
    position: fixed
    margin-left: 500px
    margin-top: 20px
    background: #fff
    border: 1px solid #DCDFE6
    border-radius: 4px
    overflow: auto

    .sticky-header
      position: sticky
      top: 0
      background: #fff
      /* 必须白色背景，否则滚动下面文字会透上来 */
      z-index: 20
      padding: 12px 0 8px 0
      margin: 0 0 16px 0

    .quickReplyResult
      ul, li
        list-style: none
        font-size: 12px
        padding: 0
        margin: 0
        line-height: 24px
        color: #ababab

      ul
        margin-bottom: 10px

    .detailBox
      padding-top: 20px

    .images
      .previewImage
        width: 150px
        margin: 0 10px 10px 0
        vertical-align: top
        border-radius: 4px
        cursor: zoom-in
        transition: opacity .2s

        &:hover
          opacity: .85

    .history-images
      padding-bottom: 12px
      margin-bottom: 12px
      border-bottom: 1px solid #e5e7eb

      .history-group
        display: flex
        gap: 8px
        margin-bottom: 8px
        align-items: flex-start
        flex-wrap: wrap

        .history-preview-img
          width: 150px
          flex-shrink: 0
          border-radius: 4px
          cursor: zoom-in
          transition: opacity .2s

          &:hover
            opacity: .85

    .sub-title
      margin: 8px 0 4px 0
      font-weight: 500

.el-tabs__nav
  width: 100%
</style>



// WEBPACK FOOTER //
// src/vms/pages/views/activity/activityCheck.vue